import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd';
import { Lightbox } from '../../../../components/lightbox';
import { NewHscModalV1Service } from './new-hsc-modal-v1.service';

const black = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';

@Component({
  selector: 'app-new-hsc-modal-v1',
  templateUrl: './new-hsc-modal-v1.component.html',
  styleUrls: ['./new-hsc-modal-v1.component.scss'],
  providers: [NewHscModalV1Service],
})
export class NewHscModalV1Component implements OnInit, OnDestroy {
  @Input() settingVisible: boolean = false;
  @Input() fileTypeList: any[] = [];

  @Output() fileList = new EventEmitter();
  @Output() modalStatus = new EventEmitter();

  downloadModalVisible = false;

  mainCameraUrl: string = black;
  subCameraUrl: string = black;
  isDeskew = false;

  imgPathArray: any[] = [];

  constructor(
    private message: NzMessageService,
    private lightbox: Lightbox,
    private hscService: NewHscModalV1Service,
  ) {}

  ngOnInit(): void {
    this.checkDeviceConnect();
  }

  ngOnDestroy(): void {
    this.closeCamera(0);
    this.closeCamera(1);
  }

  handleCloseHSCModal() {
    this.closeCamera(0);
    this.closeCamera(1);

    this.imgPathArray = [];
    this.modalStatus.emit('close');
  }

  handleCloseDownloadModal() {
    this.downloadModalVisible = false;
  }

  async checkDeviceConnect() {
    this.downloadModalVisible = false;

    const connected = await this.hscService.getDeviceConnect();
    if (!connected) {
      this.downloadModalVisible = true;
      return;
    }

    setTimeout(() => {
      this.openMainCamera();
    });
    setTimeout(() => {
      this.openSubCamera();
    }, 500);
  }

  openMainCamera() {
    this.mainCameraUrl = this.hscService.openCamera();
  }

  openSubCamera() {
    this.subCameraUrl = this.hscService.openCamera(1);
  }

  closeCamera(camera: number) {
    this.hscService.closeCamera(camera);

    if (camera === 0) {
      this.mainCameraUrl = black;
      return;
    }

    if (camera === 1) {
      this.subCameraUrl = black;
      return;
    }
  }

  // 旋转
  turnRight() {
    this.hscService.rotate(270);
  }

  turnLeft() {
    this.hscService.rotate(90);
  }

  deskew() {
    this.isDeskew = !this.isDeskew;
    this.hscService.deskew(this.isDeskew);
  }

  // 拍照
  async cameraScan(camera: number, deskew: number = 0) {
    const img = await this.hscService.scan(camera, deskew);
    this.imgPathArray.push({
      src: img,
      name: String(new Date().getTime()) + '.jpg',
      fileType: null,
    });
  }

  // 删除图片
  deleteFile(index: number) {
    this.imgPathArray.splice(index, 1);
  }

  exportFiles() {
    if (this.imgPathArray.some((o) => o.fileType === null)) {
      return this.message.warning('请选择文件类型');
    }

    this.fileList.emit(this.imgPathArray);
    this.modalStatus.emit('close');
    this.imgPathArray = [];
  }

  openPreview(index: number) {
    const albums = this.imgPathArray.map((img) => ({
      src: img.src,
      caption: img.fileName || '',
      thumb: img.url,
    }));

    this.lightbox.open(albums, index, {
      showZoom: true,
      showRotate: true,
      centerVertically: true,
    });
  }
}
